import request from '@/utils/request'
export const getConsumer = params => request.get('/api/index/consumer', { params })
export const getConsumers = params => request.get('/api/index/consumers', { params })
export const getConsumerinfo = params => request.get('/api/index/consumerinfo', { params })
export const getChangewatermeter = params => request.get('/api/index/changewatermeter', { params })
export const consumerphone = params => request.get('/api/index/consumerphone', { params })
export const getYearCount = () => { return request('/api/user/yearcount') }
export const collect = data => request.post('/api/user/collect', data)
export const getRole = () => { return request('/api/user/getrole') }
